import { CURRENCY_FORMATTER } from 'common/constants';
import { IStoreGroup } from 'v3/data/store/groupAdmin/types';

export const DDDNotExistInPtBr = [23, 25, 26, 29, 36, 39, 52, 56, 57, 58, 59, 72, 76];

export const removeCpfFormatting = (cpf: string | undefined): string => {
  if (cpf === undefined) return '';
  return cpf.toString().replace(/[^\d]/g, '');
};

export function formatCPF(cpf: string) {
  cpf = cpf.replace(/[^\d]/g, '');
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function maskCPF(cpf: string): string {
  const cleanCPF = cpf.replace(/[^\d]/g, '');

  if (cleanCPF.length !== 11) {
    return cpf;
  }

  return cleanCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, 'XXX.XXX.$3-XX');
}

export function formatPostalCode(cep: string): string {
  cep = cep.replace(/[^\d]/g, '');
  return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function formatPhoneWithAreaCode(areaCode: string, phoneNumber: string): string {
  areaCode = areaCode.replace(/[^\d]/g, '');
  phoneNumber = phoneNumber.replace(/[^\d]/g, '');

  if (phoneNumber.length === 9) {
    return `(${areaCode}) ${phoneNumber.replace(/(\d{5})(\d{4})/, '$1-$2')}`;
  } else {
    return `(${areaCode}) ${phoneNumber.replace(/(\d{4})(\d{4})/, '$1-$2')}`;
  }
}

export function currencyFormatter(value: any, formatter: boolean = true) {
  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(formatter ? value / CURRENCY_FORMATTER : value);

  return amount;
}

export function currencyFormatterForExcel(value: any, formatter: boolean = true) {
  if (!Number(value)) return '';
  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(formatter ? value : value * CURRENCY_FORMATTER);

  return amount;
}

export function numberFormatter(number){
 return new Intl.NumberFormat("pt-BR").format(number)
}

export function formatPercentage(decimal) {
  if (typeof decimal !== "number") return "";
  return `${(decimal * 100).toFixed(2)}%`;
}

export const DDDValidator = (value: any) => DDDNotExistInPtBr.every((ddd) => ddd !== Number(value.substring(1, 3)));

export function firstLetterUppercase(name) {
  if (typeof name !== 'string') {
    return '';
  }

  return name
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export const formatGroups = (groups: { storeGroup: IStoreGroup }[]): string => {
  const displayedGroups = groups.slice(0, 2).map((item) => item.storeGroup.name);
  const remainingCount = groups.length - 2;
  let result = displayedGroups.join(', ');

  if (remainingCount > 0) {
    result += ` +${remainingCount}`;
  }

  return result;
};

export const getFirstAndLastName = (fullName: string): string => {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1]}`;
};

export function amountFormatter(value: any) {
  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
  return amount;
}